module.exports = "/images/cy.svg?d5ee62f48bb692a532f924e6c25f8c77";